import axios from '../../axios';

// ANGEL TO DO IN TECH DEBT - MOVE ALL TO RESULTS MODULE AND COMMON

// TO DO : REMOVE ALL OLD DATE REFS SITE WIDE

export default {
  namespaced: true,
  state: {
    sticky: false,
  },
  getters: {
    getSticky: (state) => state.sticky,
  },
  mutations: {
    setSticky(state, payload) {
      state.sticky = payload;
    },
  },
  actions: {
  },
};
